import * as Autokana from 'vanilla-autokana';
import parsePhoneNumber from 'libphonenumber-js';
import validator from 'validator';
import SweetScroll from 'sweet-scroll';

const userName = document.getElementById('user_name');
const userFurigana = document.getElementById('user_furigana');
const userTel = document.getElementById('user_tel');
const userMail = document.getElementById('user_mail');
const userMessage = document.getElementById('user_message');
const privacyCheck = document.getElementById('privacy-check');
const sendButton = document.getElementById('send-button');
const scroller = new SweetScroll({
  duration: 1000,
  easing: 'easeOutQuint',
});

// 自動カナ入力
Autokana.bind('#user_name', '#user_furigana', { katakana: true });

// 名前のバリデーション
function nameValidation() {
  if (userName.nextSibling) userName.nextSibling.remove();

  if (userName.value === '') {
    userName.insertAdjacentHTML('afterend', '<p class="error">お名前を入力してください</p>');
    return false;
  }

  return true;
}

// フリガナのバリデーション
function furiganaValidation() {
  if (userFurigana.nextSibling) userFurigana.nextSibling.remove();

  if (userFurigana.value === '') {
    userFurigana.insertAdjacentHTML('afterend', '<p class="error">フリガナを入力してください</p>');
    return false;
  }

  return true;
}

// 電話番号のバリデーションとフォーマット
function phoneNumberValidation() {
  // エラーメッセージを削除する
  if (userTel.nextSibling) userTel.nextSibling.remove();

  const inputNumber = userTel.value;

  // 空文字が返ってきたら処理を終了
  if (inputNumber === '') {
    userTel.insertAdjacentHTML('afterend', '<p class="error">電話番号を入力してください</p>');
    return false;
  }

  try {
    const phoneNumber = parsePhoneNumber(inputNumber, 'JP');

    if (phoneNumber.isValid()) {
      // 電話番号をハイフン付きに置き換え
      userTel.value = phoneNumber.format("NATIONAL");
      return true;
    } else {
      userTel.insertAdjacentHTML('afterend', '<p class="error">正しい電話番号を入力してください</p>');
      return false;
    }
  } catch (error) {
    userTel.insertAdjacentHTML('afterend', '<p class="error">正しい電話番号を入力してください</p>');
    return false;
  }
}

function mailValidation() {
  // エラーメッセージを削除する
  if (userMail.nextElementSibling) userMail.nextElementSibling.remove();

  const inputMail = userMail.value;

  // 空文字が返ってきたら処理を終了
  if (inputMail === '') {
    userMail.insertAdjacentHTML('afterend', '<p class="error">メールアドレスを入力してください</p>');
    return false;
  }

  // メールアドレスのバリデーション
  if (validator.isEmail(inputMail)) {
    return true;
  } else {
    userMail.insertAdjacentHTML('afterend', '<p class="error">正しいメールアドレスを入力してください</p>');
    return false;
  }
}

function messageValidation() {
  // エラーメッセージを削除する
  if (userMessage.nextElementSibling) userMessage.nextElementSibling.remove();

  if (userMessage.value === '') {
    userMessage.insertAdjacentHTML('afterend', '<p class="error">お問い合わせ内容を入力してください</p>');
    return false;
  }

  return true;
}

userName.addEventListener('blur', nameValidation);
userFurigana.addEventListener('blur', furiganaValidation);
userTel.addEventListener('blur', phoneNumberValidation);
userMail.addEventListener('blur', mailValidation);
userMessage.addEventListener('blur', messageValidation);
// プラポリにチェックを入れた時の処理
privacyCheck.addEventListener('change', (event) => {
  const validations = [
    nameValidation,
    furiganaValidation,
    phoneNumberValidation,
    mailValidation,
    messageValidation,
  ];

  for (const validation of validations) {
    // バリデーションを連続して行い false が一つでもあれば処理を止める
    if (!validation()) {
      validations.forEach(validationMethod => validationMethod());
      event.target.checked = false;
      alert('フォームの入力に誤りがございます。お手数ですがご確認の上再度ご入力をお願いいたします');
      scroller.to('#contact-form');
      return false;
    }
  }

  if (event.target.checked) {
    sendButton.removeAttribute('disabled');
  } else {
    sendButton.setAttribute('disabled', '');
  }
});

// プラポリのチェックが無ければdisabled属性を追加（safari対策）
window.addEventListener('load', () => {
  if (!privacyCheck.checked) { sendButton.setAttribute('disabled', ''); }
});
